import { ICard } from "@/sections/home/ServicesSection";

export const missionVisionData: {
  heading: string;
  description: string[];
  cards: ICard[];
} = {
  heading: "Guiding principles for a secured business future",
  description: [
    "We understand that a strong future is built on robust security. Hence, all our actions help us deliver security solutions that really matter for your business",
  ],

  cards: [
    {
      icon: "mission",
      heading: "Mission",
      description:
        "To rigorously develop, maintain and upgrade the security methodologies to provide tailor-made solutions for each organization.",
    },
    {
      icon: "vision",
      heading: "Vision",
      description:
        "To equip and facilitate cyber security enthusiastic people by providing them a road map to serve and practice the most robust security cycle to serve our clients.",
    },
    {
      icon: "values",
      heading: "Values",
      description:
        "Communication that’s backed by honesty and transparency is the key for us. When blended with a commitment to innovation through advanced strategies and tools, we stay true to our vision for our clients.",
    },
  ],
};
